import { AnchorLink } from 'gatsby-plugin-anchor-links';
import React from 'react';
import MenuItems from '../data/MenuItems';

const Menu = () => {
    const listItems = Object.entries(MenuItems).map(([key, item]) => (
        <li key={'menu-' + key}>
            <AnchorLink to={'/#' + item.id} title={item.name}>
                {item.name}
            </AnchorLink>
        </li>
    ));

    return (
        <nav className="hidden md:block min-w-38 sticky top-36 self-start">
            <ul className="text-menu-color space-y-6 text-18">{listItems}</ul>
        </nav>
    );
};

export default Menu;
